const $ = window.jQuery;

class DeviceTargeting {
  constructor() {
    this.ie();
  }

  ie() {
    if (window.navigator.msPointerEnabled) {
      $('body').addClass('ie');
    }
  }
}

export default DeviceTargeting;
